import { Facebook, Link as LinkIcon, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { useT } from "@/lib/i18n";

export function ShareButton({ title }: { title: string }) {
  const { t } = useT();

  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = encodeURIComponent(`${title} — ${url}`);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(t("common.copied"));
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <div className="inline-flex items-center gap-2">
      <a
        href={`https://wa.me/?text=${text}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border hover:border-accent hover:text-accent"
        aria-label="Share on WhatsApp"
      >
        <MessageCircle size={16} />
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border hover:border-accent hover:text-accent"
        aria-label="Share on Facebook"
      >
        <Facebook size={16} />
      </a>
      <button
        type="button"
        onClick={copy}
        className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border hover:border-accent hover:text-accent"
        aria-label="Copy link"
      >
        <LinkIcon size={16} />
      </button>
    </div>
  );
}
